export default __webpack_public_path__ + "static/media/five.5fcd1bb6.png";